var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselCollege = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "6l2gsqnr6a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#6l2gsqnr6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.518 19.686v9.572a13.81 13.81 0 0 0 3.887 4.516c2.376 1.774 4.68 2.191 7.524 2.727 4.246.799 7.638.432 9.26.184 3.223-.494 5.325-1.42 5.958-1.71 0 0 3.254-1.496 4.733-3.5.623-.847.978-1.75.978-1.75.116-.294.194-.547.245-.733v-9.406",
    fill: "#4B98AA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49848E",
    d: "M0 14.448v1.893l24.838 14.462.018-1.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#317A82",
    d: "m50 14.546-.01 1.896-25.154 14.361-.018-1.954"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72BBCC",
    d: "M.002 14.42 24.874 0 50 14.546 24.89 29.113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.098 13.29v.825c.169.121.422.284.76.414.199.078 1.328.514 2.359-.018.163-.085.402-.233.64-.493l.034-.906",
    fill: "#49ACBC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#72BBCC",
    cx: 24.999,
    cy: 13.247,
    rx: 1.892,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.329 12.645 18.6 10.543c.006.016.086.304-.085.488-.168.183-.52.2-.775-.029L24.602 12.913a.836.836 0 0 1 .683-.286",
    fill: "#72BBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.716 13.658 43.091 24.59c.016-.004.306-.076.384-.315.076-.236-.084-.55-.408-.658L24.593 12.897a.868.868 0 0 0-.043.356c.018.18.088.313.13.378",
    fill: "#49ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C75F",
    d: "m42.47 31.445-2.786 3.707v10.28l.95.568V35.548l3.013-3.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE4AE",
    d: "m43.38 31.818-2.777 3.73.03 10.452 6.05-3.453.032-10.393-2.717-.763"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72BBCC",
    d: "M43.359 23.224v8.72l.779-.52-.181-8.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49ACBC",
    d: "M42.433 23.768v7.694l.92.511.006-8.165"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    transform: "rotate(-52.64 43.732 32.947)",
    cx: 43.732,
    cy: 32.947,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.78 35.465c-.289 0-.776.047-1.278.332-.815.465-1.093 1.235-1.198 1.528-.12.333-.26.743-.118 1.215.053.177.164.539.472.685.353.168.598-.124 1.217-.02.225.038.475.08.61.275.247.362-.11.962-.178 1.078-.292.492-.745.709-.983.822-.456.22-.884.27-1.177.275l-.106.564c.17.046.459.103.807.065 1.17-.128 1.812-1.193 1.904-1.352.116-.199.3-.506.345-.956.03-.304.094-.781-.205-1.15-.277-.34-.712-.402-1-.441-.366-.051-.6.182-.818.043-.132-.085-.175-.233-.204-.333-.133-.45.128-.887.268-1.117.156-.257.313-.394.355-.43.09-.076.234-.196.451-.268.223-.074.422-.065.689-.054.107.005.195.014.259.021l.003-.782",
    fill: "#4B98AA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B98AA",
    d: "m44.017 35.976-.06-1.36-.595.149.078 1.1M43.466 41.659l.03 1.36.597-.136-.055-1.101"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselCollege);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-college.298fae729586f09afba50674a9f9ae10.svg";